import objFactory from "_src/engine/factories/object";
import FrameBuffer from "_src/engine/framebuffer";
import primitiveFactory from "_src/engine/factories/primitive";
import {primitiveType, blendFactor, pixelBufferType, attachmentId} from "_src/engine/constants";

import Pass from "_src/render_graph/pass";
import resourceManager from "_src/render_graph/resource_manager";
import FXAAShader from "_src/shaders/fxaa/fxaa";
import CopyShader from "_src/shaders/copy/copy";
import appState from "_src/app_state";

export default class AntialiasingPass extends Pass {

  constructor(attachmentsStorage, camera) {

    super(attachmentsStorage);

    this._maskedMode = true;

    this.init(camera);

  }

  init(camera) {

    const scene = this._addScene(camera);
    scene.clearedColor = false;

    const copyScene = this._addScene(camera);
    copyScene.clearedColor = false;

    const shader = new FXAAShader({});
    shader.setSourceBlendFactor(blendFactor.ONE);
    const drawScreenPlane = objFactory.createDrawable(shader);
    drawScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
    scene.add(drawScreenPlane);

    const copyShader = new CopyShader();
    const copyScreenPlane = objFactory.createDrawable(copyShader);
    copyScreenPlane.addGeometryChunk(primitiveFactory.create(primitiveType.SCREEN_QUAD));
    copyScene.add(copyScreenPlane);

    const transparentBackfaceEnabled = appState.getStateValue("backFaceMode") === appState.BM_TRANSPARENT;
    this.setMaskedModeEnabled(transparentBackfaceEnabled);
  }

  update() {

    const scenes = this.getScenes();
    const width = scenes[0].camera.viewport[2];
    const height = scenes[0].camera.viewport[3];

    const {drawFramebuffer, copyFramebuffer} = this._initFramebuffers(width, height);

    scenes[0].setFramebuffer(drawFramebuffer);
    scenes[1].setFramebuffer(copyFramebuffer);

  }

  _initFramebuffers(width, height) {

    const inputColor = this.attachmentsStorage[attachmentId.OUTPUT_COLOR_TEXTURE];
    const maskColor = resourceManager.initBuffer(pixelBufferType.T_RGBA, { width, height });
    const drawFramebuffer = new FrameBuffer([maskColor], null);
    const copyFramebuffer = new FrameBuffer([inputColor], null);

    const drawScene = this.getMainScene();
    const drawScreenPlane = this.getScreenQuad(drawScene);
    drawScreenPlane.setTexture(inputColor, 0);

    if (this._maskedMode) {
      const inputMask = this.attachmentsStorage[attachmentId.OBJECT_ID_TEXTURE];
      drawScreenPlane.setTexture(inputMask, 1);
    }

    const copyScene = this.getSecondScene();
    const copyScreenPlane = this.getScreenQuad(copyScene);
    copyScreenPlane.setTexture(maskColor, 0);

    return {drawFramebuffer, copyFramebuffer};

  }

  setMaskedModeEnabled(enabled) {
    const drawScene = this.getMainScene();
    const drawScreenPlane = this.getScreenQuad(drawScene);
    drawScreenPlane.shader.setDirective("MASKED_MODE", enabled);

    this._maskedMode = enabled;
    if (enabled) {
      const inputMask = this.attachmentsStorage[attachmentId.OBJECT_ID_TEXTURE];
      drawScreenPlane.setTexture(inputMask, 1);
    }
  }

}
